/*@ngInject*/
export default function deviceStateFilter($sce) {
    return function(state) {
        switch(state) {
            case 0:
                return $sce.trustAsHtml('<span class="text-warning">PENDING</span>');
            case 1:
                return $sce.trustAsHtml('<span class="text-success">SUCCESS</span>');
            case 2:
                return $sce.trustAsHtml('<span class="text-danger">FAILED</span>');
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/new_devices_status/state.filter.js
 **/